import IBasicResponse from "@/interfaces/Data/IBasicResponse";
import { IAddUser, IBaseUser, IEditOtherUserProfile, IEditUserPassword, IEditUserProfile, IInspectionUser, IOrganizationUser, IUserProfile } from "@/interfaces/Data/User";
import baseApi from "@/redux/features/baseApi";

const apiWithTag = baseApi.enhanceEndpoints({ addTagTypes: ["User", "Users"] });
export const userApi = apiWithTag.injectEndpoints({
  endpoints: (build) => ({

    getProfile: build.query<IUserProfile, void>({
      query: (
      ) => {
        return {
          url: `/web/api/user`,
          method: "GET",
        };
      },
      providesTags: [{ type: "User", id: "profile" }],
      transformResponse: (response: IBasicResponse<IUserProfile>) => {
        return response.data;
      },

    }),
    editProfile: build.mutation<void, IEditUserProfile>({
      query: (
        data
      ) => {

        return {
          url: `/web/api/user/profile`,
          method: "PUT",
          body: data
        };
      },
      invalidatesTags: [{ type: "User", id: "profile" }],
    }),
    editPassword: build.mutation<void, IEditUserPassword>({
      query: (
        data
      ) => {
        return {
          url: `/web/api/user/password`,
          method: "PUT",
          body: data
        };
      },

    }),

    getUsers: build.query<Array<IInspectionUser | IOrganizationUser>, { type: "inspection" | "organization", organizationId?: string }>({
      query: (
        data
      ) => {
        const { type, organizationId } = data;
        let url = "";
        if (type === "organization") {
          url = `/web/api/organizations/${organizationId}/users`;
        } else if (type === "inspection") {
          url = `/web/api/inspection/users`;
        }
        return {
          url: url,
          method: "GET"
        };
      },
      providesTags: [{ type: "Users" }],
      transformResponse: (response: IBasicResponse<Array<IInspectionUser | IOrganizationUser>>) => {

        return response.data;
      },
    }),

    getUser: build.query<IInspectionUser | IOrganizationUser, IBaseUser & { type: "inspection" | "organization", organizationId?: string }>({
      query: (
        data
      ) => {
        const { userId, type, organizationId } = data;
        let url = "";
        if (type === "organization") {
          url = `/web/api/organizations/${organizationId}/users/${userId}`;
        } else if (type === "inspection") {
          url = `/web/api/inspection/users/${userId}`;
        }
        return {
          url: url,
          method: "GET"
        };
      },
      providesTags: (result, error, data) => {
        return [{ type: "User", id: `${data.userId}` }]
      },
      transformResponse: (response: IBasicResponse<IInspectionUser | IOrganizationUser>) => {

        return response.data;
      },
    }),


    addUser: build.mutation<void, IAddUser & {
      organizationId?: string
    }>({
      query: (
        data
      ) => {
        const { type, organizationId } = data;
        let url = "";
        if (type === "organization") {
          url = `/web/api/organizations/${organizationId}/users`;
        } else if (type === "inspection") {
          url = `/web/api/inspection/users`;
        }
        return {
          url: url,
          method: "POST",
          body: {
            account: data.account,
            password: data.password,
            name: data.name,
            mail: data.mail,
            type: data.type,
            category: data.category
          }
        };
      },
      invalidatesTags: [{ type: "Users" }],
    }),

    editUser: build.mutation<void, IEditOtherUserProfile & {
      type: "inspection" | "organization",
      organizationId?: string
    }>({
      query: (
        data
      ) => {
        const { type, organizationId, userId } = data;
        let url = "";
        if (type === "organization") {
          url = `/web/api/organizations/${organizationId}/users/${userId}`;
        } else if (type === "inspection") {
          url = `/web/api/inspection/users/${userId}`;
        }

        return {
          url: url,
          method: "PUT",
          body: {
            name: data.name,
            password: data.password,
            mail: data.mail,
            type: data.type
          }
        };
      },
      invalidatesTags: [{ type: "Users" }],
    }),

    deleteUser: build.mutation<void, {
      userId: string
      type: "inspection" | "organization",
      organizationId?: string
    }>({
      query: (
        data
      ) => {
        const { type, organizationId, userId } = data;
        let url = "";
        if (type === "organization") {
          url = `/web/api/organizations/${organizationId}/users/${userId}`;
        } else if (type === "inspection") {
          url = `/web/api/inspection/users/${userId}`;
        }

        return {
          url: url,
          method: "DELETE"
        };
      },
      invalidatesTags: [{ type: "Users" }],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useEditPasswordMutation,
  useEditProfileMutation,
  useGetUsersQuery,
  useGetUserQuery,
  useAddUserMutation,
  useDeleteUserMutation,
  useEditUserMutation
} = userApi;
